import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, Transition as _Transition, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2da2c072"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat_warp" }
const _hoisted_2 = { class: "chat_head mod_c_title" }
const _hoisted_3 = { class: "chat_watch" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "观看页显示", -1))
const _hoisted_5 = { class: "chat_operate" }
const _hoisted_6 = { class: "operate_wrap" }
const _hoisted_7 = { class: "chat_operate_btn_wrap" }
const _hoisted_8 = { class: "operate_form_wrap" }
const _hoisted_9 = { class: "form_item" }
const _hoisted_10 = { class: "form_item" }
const _hoisted_11 = { class: "form_item_btn" }
const _hoisted_12 = {
  key: 0,
  class: "chat_content"
}
const _hoisted_13 = {
  key: 1,
  class: "chat_content"
}
const _hoisted_14 = {
  key: 2,
  class: "chat_content"
}
const _hoisted_15 = { class: "chat_switch_tab" }
const _hoisted_16 = { class: "chat_switch_list_wrap" }
const _hoisted_17 = { class: "chat_switch_list" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "chat_switch_item_avatar" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "chat_switch_item_content" }
const _hoisted_22 = { class: "csic_name" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "chat_send_wrap" }
const _hoisted_25 = { class: "chat_send" }
const _hoisted_26 = {
  class: "nav_img_tbody",
  trigger: "click"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "表情", -1))
const _hoisted_28 = { class: "nav_img_tbody" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图片", -1))
const _hoisted_30 = {
  key: 0,
  class: "nav_img_tbody"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "机器人", -1))
const _hoisted_32 = { class: "nav_img_tbody" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "投票", -1))
const _hoisted_34 = { class: "nav_img_tbody" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "打卡", -1))
const _hoisted_36 = { class: "nav_img_tbody" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "人数", -1))
const _hoisted_38 = { class: "nav_img_tbody" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "机器人", -1))
const _hoisted_40 = { class: "nav_img_tbody" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "弹窗广告", -1))
const _hoisted_42 = {
  key: 0,
  class: "nav_img_tbody"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "多语实时字幕", -1))
const _hoisted_44 = { class: "nav_img_tbody" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "红包", -1))
const _hoisted_46 = { class: "nav_img_tbody" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "抽奖", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "管理员", -1))
const _hoisted_49 = ["src"]
const _hoisted_50 = {
  key: 0,
  class: "chat_send_mark"
}
const _hoisted_51 = { class: "img_pos" }
const _hoisted_52 = {
  key: 0,
  class: "img_box"
}
const _hoisted_53 = {
  key: 0,
  class: "img_mask"
}
const _hoisted_54 = {
  key: 1,
  class: "img_hover"
}
const _hoisted_55 = { class: "img_icon" }
const _hoisted_56 = ["src"]
const _hoisted_57 = { class: "official_authoriyt" }
const _hoisted_58 = { class: "nick_name" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name_head" }, "昵称", -1))
const _hoisted_60 = { class: "nick_input" }
const _hoisted_61 = { class: "text_number" }
const _hoisted_62 = { class: "official_avatar" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "avatar_name" }, "头像", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, [
  /*#__PURE__*/_createTextVNode("建议图片小于2M，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("支持jpg、jpeg、png、gif")
], -1))
const _hoisted_65 = { class: "delete_btn" }
const _hoisted_66 = ["onKeydown"]
const _hoisted_67 = { class: "robot_avatar" }
const _hoisted_68 = ["src"]
const _hoisted_69 = { class: "chat_robot_content" }
const _hoisted_70 = { class: "robot_function" }
const _hoisted_71 = { class: "robot_popover" }
const _hoisted_72 = { class: "blank" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "blank_span" }, "随机地址：", -1))
const _hoisted_74 = { class: "flex" }
const _hoisted_75 = { class: "flex" }
const _hoisted_76 = {
  key: 0,
  class: "flex"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "blank_span" }, "自定义地址：", -1))
const _hoisted_78 = { class: "robot_usercord" }
const _hoisted_79 = { class: "robot_usercord" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { key: 1 }

import { computed, createVNode, defineAsyncComponent, getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import {
  Switch,
  Badge,
  Button,
  message,
  Modal,
  Drawer,
  Tooltip,
  Image,
  Popover,
  Radio,
  Upload,
  Select,
  Checkbox,
} from 'ant-design-vue';
import {
  ZoomInOutlined,
  DeleteOutlined,
  QuestionCircleFilled,
  DoubleRightOutlined,
  LoadingOutlined,
} from '@ant-design/icons-vue';
import { ExclamationCircleFilled } from '@ant-design/icons-vue';
import ChatMessage from './ChatMessage.vue';
import { useConsoleStore } from '@/pinia/console';
import http from '@/api';
import { getHelperStatus, getToken, setHelperData } from '@/plugins/cookie';
import CUpload from '@/components/CUpload.vue'; // 上传图片  组件
import { msgid } from '@/utils/format';
import { useDebounce } from '@/hooks/useDebounce';
import { GroupChat, PrivateChat } from '@/pinia/types/console';
import EventBus from '@/components/EventBus';
import { insertHtml, onPaste, setFocus } from '@/utils/range';
import { useSocketStore } from '@/pinia/socket';
import { useHomeStore } from '@/pinia/home';
import { useStore } from 'vuex';
import https from '@/api/exportList';
import { notification } from 'ant-design-vue';

interface RootEmoji {
  key: string;
  content: string;
}
// 右侧抽屉弹出层模块
interface SendMsg {
  content: string;
  msg_id: string;
  msg_type: string;
  source?: number;
  studio_id: number;
  type: string;
  group_msg_id?: string;
  to_content?: any;
  to_nickname?: string;
  to_uid?: number;
  robot_info?: string;
  addr?: string;
}

interface PrivateMsgForm extends SendMsg {
  alias: string;
  // content: string;
  // msg_id: string;
  // msg_type: string;
  // studio_id: number;
  to_avatar: string;
  to_level: number;
  // to_nickname: string;
  // to_uid: number;
  // type: 'send_private';
}
// 发送私聊信息
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: never;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LiveChat',
  setup(__props) {

const EmojiDrawer = defineAsyncComponent(() => import('../liveExpress/Emoji.vue')); // 表情组件
const NumberSetting = defineAsyncComponent(() => import('../liveExpress/NumberSetting.vue')); // 人数设置
const PunchClock = defineAsyncComponent(() => import('../liveExpress/PunchClock.vue')); // 打卡
const AiSubtitles = defineAsyncComponent(() => import('../liveExpress/AiSubtitlesDrawer.vue')); // AI翻译
const PopupAdverst = defineAsyncComponent(() => import('../liveExpress/PopupAdverst.vue')); // 弹窗广告
const RobotRecord = defineAsyncComponent(() => import('../liveExpress/RobotRecord.vue')); // 机器人组件
const Comment = defineAsyncComponent(() => import('../liveExpress/Comment.vue')); //评论库
const VoteDrawer = defineAsyncComponent(() => import('../liveExpress/Vote.vue')); // 投票 组件
const RedPacket = defineAsyncComponent(() => import('../liveExpress/RedPacket.vue')); // 红包组件
// 聊天信息渲染模块
const GroupMessage = defineAsyncComponent(() => import('./GroupMessage.vue')); // 公聊内容组件
const LightGroupMessage = defineAsyncComponent(() => import('./LightGroupMessage.vue')); // 公聊内容组件-轻聊版
const StandLogttery = defineAsyncComponent(() => import('../lottery/StandLogttery.vue')); // 普通抽奖
const ActivityLogttery = defineAsyncComponent(() => import('../lottery/ActivityLogttery.vue')); // 活动抽奖
const consoleStore = useConsoleStore();
const route = useRoute();
const aSwitch = Switch;
const aBadge = Badge;
const aButton = Button;
const aDrawer = Drawer;
const aTooltip = Tooltip;
const aPopover = Popover;
const aModal = Modal;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aUpload = Upload;
const aImage = Image;
const aSelect = Select;
const aCheckbox = Checkbox;

const store = useStore();
const homeStore = useHomeStore();
const helperStatus = getHelperStatus();
const helperData = store.state.user.helperInfo.data;
const aiSubitilesRole = computed(() => {
  if (!helperStatus) return homeStore.funcData?.AiSubtitles;
  else return homeStore.funcData?.AiSubtitles && store.state.user.helperInfo.set === 1;
}); // 实时字幕权限
const RedEnvelope = computed(() => {
  if (!helperStatus) return homeStore.funcData?.RedPack;
  else return homeStore.funcData?.RedPack && store.state.user.helperInfo.set === 1;
}); //红包权限
const isParentStudio = computed(() =>
  consoleStore.consoleInfo.id ? consoleStore.consoleInfo.id === consoleStore.consoleInfo.studioPid : false
);

const discussRole = computed(() => homeStore.funcData.RobotReview);

// 互动聊天-观看页显示的控制
const onChangeChatShow = () => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleFilled),
    content: `确认${consoleStore.consoleInfo.chatVisible ? '关闭' : '开启'}观看页聊天菜单？`,
    onOk() {
      return new Promise((resolve, reject) => {
        http.liveChat
          .chatSwitch({
            status: Number(!consoleStore.consoleInfo.chatVisible),
            studio_id: route.params.studioId,
          })
          .then(() => {
            consoleStore.consoleInfo.chatVisible = !consoleStore.consoleInfo.chatVisible;
            resolve({});
          })
          .catch((err: any) => {
            message.warn(err.data.error);
            reject(err);
          });
      });
    },
  });
};

// 聊天记录-清空
const onClearMsg = () => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleFilled),
    content: '此操作将彻底清除聊天(红包)记录, 是否继续?',
    onOk() {
      return new Promise((resolve, reject) => {
        http.liveChat
          .deleteChat({
            studio_id: route.params.studioId,
          })
          .then((res) => {
            message.success(res.data.message);
            resolve(res);
          })
          .catch((err) => {
            message.warn(err.data.error);
            reject(err);
          });
      });
    },
  });
};

// const chatType = ref(1); // 聊天类型 公共 1 与 私聊 0
// const activedMsg = reactive<ActivePrivateChat>({
//   id: 0,
//   identity: 0,
//   page:1,
//   pageNum:20,
// }); // 当前私聊的信息对象

// 私聊记录-详情
const getPrivateChatView = () => {
  if (consoleStore.privateMsg.list.length !== 0) {
    const item = consoleStore.currentDialog.pmsgItem.id ? consoleStore.currentDialog.pmsgItem : consoleStore.privateMsg.list[0];
    consoleStore.getDialogMsg(parseInt(route.params.studioId as string), item);
  }
};

// 用于区别选中样式
const checkedTab = (tabId: number) => {
  return consoleStore.chatType === tabId;
};
const chatlistRef = ref();
const listVisible = ref(false); // 聊天弹层
/**
 * @description 切换 私聊 0 or 公聊 1 列表
 */
const onChangeChatType = (tabId: number): void => {
  if (tabId === consoleStore.chatType && tabId === 1) {
    return;
  } else if (consoleStore.chatType === 1 && tabId === 0) {
    getPrivateChatView();
  }
  consoleStore.chatType = tabId;
  if (consoleStore.chatType === 0 && !listVisible.value && tabId === 0) {
    consoleStore.getPrivateMsg(parseInt(route.params.studioId as string));
    listVisible.value = true;
  } else {
    listVisible.value = false;
  }
};
/**
 * @description 私聊详情
 */
const onSwitchInfo = (item: PrivateChat) => {
  if (item.news === 1) {
    consoleStore.privateMsg.newMsgCount -= 1;
  }
  consoleStore.getDialogMsg(parseInt(route.params.studioId as string), item);
  listVisible.value = false;
};

// 聊天设置
const onChangeSet = async (index: number) => {
  try {
    let statusForm = false;
    switch (index) {
      case 0:
        statusForm = consoleStore.consoleInfo.groupStatus;
        break;
      case 1:
        statusForm = consoleStore.consoleInfo.anonymousStatus;
        break;
      case 2:
        statusForm = consoleStore.consoleInfo.privateStatus;
        break;
      case 3:
        statusForm = consoleStore.consoleInfo.barrageVisible;
        break;
      case 4:
        statusForm = consoleStore.consoleInfo.barrageReview;
        break;
      case 5:
        statusForm = consoleStore.consoleInfo.reviewStatus;
        break;
      case 6:
        statusForm = consoleStore.consoleInfo.commentNumVisible;
        break;
      case 7:
        statusForm = consoleStore.consoleInfo.notityStatus;
        break;
      case 8:
        statusForm = consoleStore.consoleInfo.picStatus;
        break;
      case 9:
        statusForm = consoleStore.consoleInfo.addressStatus;
        break;
      default:
        statusForm = false;
        break;
    }
    await http.liveChat.onSetchatGroup({
      status: Number(statusForm),
      studio_id: route.params.studioId,
      key: index,
    });
  } catch (err: any) {
    message.error(err.data.error);
  }
};

const exportRef = ref();
// 聊天互动导出弹层
const exportForm = reactive({
  visible: false,
  chatType: 8,
  contentType: 0,
  cron: 1,
});
const { proxy }: any = getCurrentInstance();
const messageTip = ref();
const onExportChat = useDebounce(() => {
  if (helperData == 0 && helperStatus) {
    message.warning('当前助手账号没有导出无权限！');
    return;
  }
  const chatType = consoleStore.consoleInfo.chatType === 2 ? exportForm.chatType : 26; // 判断标准版与轻聊版
  const data = {
    studio_id: route.params.studioId,
    type: chatType,
    is_cron_download: exportForm.cron,
    status: exportForm.contentType,
  };
  https
    .excel_regional_distribution({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error;
      openNotificationWithIcon('error');
    });
  // 1 全部  2 观看量排名  3 设备占比  4 观看途径  5 访问来源  6 榜单排行  7 观看流水
  // 8 群聊记录 9 私聊记录  10 邀约码  11 直播间付费记录  12 表单用户信息 13 投票记录 14 广告统计 26 轻聊版-群聊记录
  // status 群聊记录 ：0 全部 1 审核过的    表单信息：0 仅表单 1 所有数据
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
    duration: 5,
  });
};

const chatSetBtnRef = ref();
const operaVisible = ref(false); // 聊天互动设置弹层
const openOperaVisible = () => {
  operaVisible.value = !operaVisible.value;
};
const exit = (e: MouseEvent) => {
  if (chatlistRef.value && !chatlistRef.value.contains(e.target) && listVisible.value) {
    listVisible.value = false;
  } else if (!chatSetBtnRef.value.contains(e.target) && operaVisible.value) {
    operaVisible.value = false;
  } else if (exportRef.value.contains(e.target)) {
    exportForm.visible = true;
  } else if (!exportRef.value.contains(e.target) && exportForm.visible) {
    exportForm.visible = false;
  }
};
onMounted(() => {
  document.addEventListener('click', exit);
});
onUnmounted(() => {
  document.removeEventListener('click', exit);
});

const chatInputRef = ref(); // 消息框dom对象
const msgContent = ref(''); // 消息变量
// const msgEmojiArr = ref(''); // 消息变量

const resetInput = () => {
  msgContent.value = '';
  // imageDel();
  chatInputRef.value.innerHTML = '';
  toMsgObjStr.value = '';
};

const msgRef = ref<Element>();
const toMsgObj = ref<GroupChat | undefined>();
const toMsgObjStr = ref(''); // 消息框内容

const onClickComment = (data: any) => {
  toMsgObj.value = data as GroupChat;
  toMsgObjStr.value = `<span style="color: #9aa1a9;" contenteditable="false">回复${data.nickname}：</span>`;
  chatInputRef.value.innerHTML = toMsgObjStr.value;
  setFocus(chatInputRef.value);
};
EventBus.on('toComment', onClickComment);
onUnmounted(() => {
  EventBus.off('toComment', onClickComment);
});

const replaceEnter = (e: Event) => {
  // e.preventDefault();
  // insertHtml('<br><br>');
  return false;
};

/**
 * @description 发送公聊信息
 * @param content 发送内容
 * @param msgType 发送的消息类型
 */
const sendGroupMsg = (content: string, msgType: string) => {
  const formData: SendMsg = {
    content: content,
    msg_id: msgid(),
    msg_type: msgType,
    source: 0,
    studio_id: consoleStore.consoleInfo.id,
    type: 'send_group',
    addr: undefined,
  };
  if (consoleStore.robotVisible) {
    formData.source = 1;
    formData.robot_info = JSON.stringify(consoleStore.robotInfo);
    if (!consoleStore.robotInfo.random_area) formData.addr = robotAdress.value;
  }
  if (toMsgObj.value) {
    formData.group_msg_id = toMsgObj.value.msg_id;
    formData.to_content = toMsgObj.value.content;
    formData.to_nickname = toMsgObj.value.nickname;
    formData.to_uid = toMsgObj.value.uid;
  }
  http.liveChat
    .sendGroup(formData)
    .then(() => {
      resetInput();
      imageDel();
      imgLoading.value = false;
      if (consoleStore.robotVisible && !consoleStore.robotInfo.lock) {
        randomRobotInfo();
        lockRobotInfo();
      }
    })
    .catch((err) => {
      message.error(err.data.error);
    })
    .finally(() => {
      if (toMsgObj.value) {
        toMsgObj.value = undefined;
      } else {
        msgRef.value && (msgRef.value.scrollTop = 0);
      }
    });
};

const sendPrivateMsg = () => {
  let formData: PrivateMsgForm;
  const user: any = consoleStore.currentDialog.user ? consoleStore.currentDialog.user : consoleStore.currentDialog.pmsgItem;
  if (imageUrl.value) {
    formData = {
      alias: user.alias,
      to_avatar: user.to_avatar,
      to_level: user.to_level,
      to_nickname: user.to_nickname,
      to_uid: user.to_uid,
      content: imageId.value,
      msg_id: msgid(),
      msg_type: 'img',
      studio_id: consoleStore.consoleInfo.id,
      type: 'send_private',
    };
  } else {
    formData = {
      alias: user.alias,
      to_avatar: user.to_avatar,
      to_level: user.to_level,
      to_nickname: user.to_nickname,
      to_uid: user.to_uid,
      content: msgContent.value,
      msg_id: msgid(),
      msg_type: 'txt',
      source: 0,
      studio_id: consoleStore.consoleInfo.id,
      type: 'send_private',
    };
  }
  http.liveChat
    .sendPrivate(formData)
    .then(() => {
      resetInput();
      msgRef.value && (msgRef.value.scrollTop = 0);
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};

/**
 * @description 发送轻聊版-公聊信息
 * @param content 发送内容
 * @param msgType 发送的消息类型
 */
const sendLightGroupMsg = (content: string, msgType: number) => {
  const formData: any = {
    content: content,
    message_type: msgType,
    source: 0,
    studio_id: consoleStore.consoleInfo.id,
    robot_info: undefined,
    addr: undefined,
  };
  if (consoleStore.robotVisible) {
    formData.source = 1;
    formData.robot_info = JSON.stringify(consoleStore.robotInfo);
    if (!consoleStore.robotInfo.random_area) formData.addr = robotAdress.value;
  }

  http.liveChat
    .sendLightGroup(formData)
    .then(() => {
      resetInput();
      imageDel();
      imgLoading.value = false;
      msgRef.value && (msgRef.value.scrollTop = 0); // 消息发送后聊天聊天列表回顶

      if (consoleStore.robotVisible && !consoleStore.robotInfo.lock) {
        randomRobotInfo();
        lockRobotInfo();
      }
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};
const socketStore = useSocketStore();

/**
 * @description 发送信息的入口
 */
const sendMsg = async () => {
  if (socketStore.socket && socketStore.socket.wsStatus().status !== 1) {
    return;
  }
  if (!imageUrl.value) {
    let html = chatInputRef.value.innerHTML.replace(/<div>/g, '<br>');
    html = html.replace(/<\/div>/g, '');
    chatInputRef.value.innerHTML = html;
    const formatStr = chatInputRef.value.innerHTML.replaceAll('<br><br>', '\n').replaceAll('<br>', '\n');
    let str: string = formatStr.replace(
      /<img [^>]*class="emoji" [^>]*alt=['"]([^'"]+)[^>]*>/gi,
      (match: any, capture: any) => capture
    );
    if (toMsgObjStr.value && !str.includes(toMsgObjStr.value)) {
      toMsgObjStr.value = '';
      toMsgObj.value = undefined;
    }
    msgContent.value = str.replace(toMsgObjStr.value, '');
    chatInputRef.value.innerHTML = '';
  } else {
    await handleUpload();
  }
  if (!imageUrl.value && !msgContent.value) {
    return;
  }

  if (consoleStore.consoleInfo.chatType === 1) {
    let message_type = 1;
    let data = '';
    if (imageUrl.value) {
      message_type = 3;
      data = JSON.stringify({
        id: imageId.value,
        url: imageUrl.value,
      });
    } else {
      message_type = 1;
      data = msgContent.value;
      data = JSON.stringify(data.replace(/>/g, '&gt;').replace(/</g, '&lt;'));
    }
    resetInput();
    sendLightGroupMsg(data, message_type);
  } else if (consoleStore.chatType) {
    let message_type = 'txt';
    let data = '';
    if (imageUrl.value) {
      message_type = 'img';
      data = imageId.value;
    } else {
      message_type = 'txt';
      data = msgContent.value;
    }
    resetInput();
    sendGroupMsg(data, message_type);
  } else {
    sendPrivateMsg();
  }
};

/**
 * 迁移
 */
// 聊天 功能
const showEmoj = ref(false);
const voteVisible = ref(false); // 投票 显示
const showPacket = ref(false); // 红包
const packetVisible = ref(false);
// 弹层对象
const lotteryDrawer = reactive({
  type: 2,
  btnVisible: false,
  LayoutVisible: false,
  numberPeople: false, //人数设置
  punch: false, //打卡
  popup: false, //弹窗广告
  aistr: false, //ai翻译
});
const onCloseLotter = () => {
  lotteryDrawer.btnVisible = false;
  lotteryDrawer.type = 1;
  lotteryDrawer.LayoutVisible = false;
  lotteryDrawer.numberPeople = false;
  lotteryDrawer.punch = false;
  lotteryDrawer.popup = false;
  lotteryDrawer.aistr = false;
};

const robotChat = ref(false);
const activedKey = ref();
const packType = ref<number>(1);
const showSend = (keys: number, lottery = 1) => {
  activedKey.value = keys;
  keys != 6 && keys != 1 ? (consoleStore.robotVisible = false) : '';
  switch (keys) {
    case 3:
      voteVisible.value = true;
      break;
    case 4:
      lotteryDrawer.punch = true;
      break;
    case 5:
      lotteryDrawer.numberPeople = true;
      break;
    case 6:
      consoleStore.robotVisible = !consoleStore.robotVisible;
      showEmoj.value = false;
      lockRobotInfo();
      break;
    case 7:
      lotteryDrawer.popup = true;
      break;
    case 9:
      lotteryDrawer.btnVisible = false;
      lotteryDrawer.type = lottery;
      lotteryDrawer.LayoutVisible = true;
      break;
    case 10:
      lotteryDrawer.aistr = true;
      break;
    default:
  }
};

const closeThis = () => {
  showPacket.value = false;
};
const packetView = (type: number) => {
  packType.value = type;
  packetVisible.value = false;
  showPacket.value = true;
};
// const isBottomOfList = computed(() => {
//   if (consoleStore.consoleInfo.chatType === 1) {
//     return consoleStore.lightGroupMsg.list.length === consoleStore.lightGroupMsg.pageConfig.totalSize;
//   }
//   return false;
// });
const updateList = async () => {
  //轻聊
  if (consoleStore.consoleInfo.chatType === 1) {
    const groupList = consoleStore.lightGroupMsg;
    const pageConfig = consoleStore.lightGroupMsg.pageConfig;
    //快到底时----加载
    if (pageConfig.totalSize && groupList.list.length < pageConfig.totalSize) {
      await consoleStore.getLightGroupMsg(parseInt(route.params.studioId as string), pageConfig.current + 1);
    }
  } else if (consoleStore.consoleInfo.chatType === 2 && consoleStore.chatType === 1) {
    const groupList = consoleStore.groupMsg;
    const pageConfig = consoleStore.groupMsg.pageConfig;
    if (pageConfig.totalSize && groupList.list.length < pageConfig.totalSize) {
      consoleStore.getGroupMsg(parseInt(route.params.studioId as string), pageConfig.current + 1);
    }
  } else if (consoleStore.consoleInfo.chatType === 2 && consoleStore.chatType === 0) {
    const groupList = consoleStore.currentDialog;
    const pageConfig = consoleStore.currentDialog.pageConfig;
    if (pageConfig.totalSize && groupList.list.length < pageConfig.totalSize) {
      consoleStore.updataDialogMsg(parseInt(route.params.studioId as string), pageConfig.current + 1);
    }
  }
};
const updatePrivateList = useDebounce(() => {
  const pageConfig = consoleStore.privateMsg.pageConfig;
  if (pageConfig.totalSize && consoleStore.privateMsg.list.length < pageConfig.totalSize) {
    consoleStore.updatePrivateMsg(parseInt(route.params.studioId as string), pageConfig.current + 1);
  }
});

const onScrollTop = () => {
  consoleStore.getNewGroupList();
  msgRef.value && (msgRef.value.scrollTop = 0); // 消息发送后聊天聊天列表回顶
};

// 关闭 表情  红包

// 上传头像
const fileList = ref<any>([]);
const imageUrl = ref('');
const imageId = ref('');
const imgLoading = ref(false);

// 上传图片预览
const handleRemove = (file: FileItem) => {
  const index = fileList.value.indexOf(file);
  const newFileList = fileList.value.slice();
  newFileList.splice(index, 1);
  fileList.value = newFileList;
};
const beforeUpload = (file: FileItem) => {
  if (fileList.value.length === 1) {
    handleRemove(fileList.value[0]);
  }
  fileList.value = [...fileList.value, file];
  imageUrl.value = window.URL.createObjectURL(fileList.value[0]);
  return false;
};

const handleUpload = () => {
  imgLoading.value = true;
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('images', fileList.value[0] as any);
    http.liveExpress
      .upImages(formData)
      .then((res) => {
        fileList.value = [];
        imageUrl.value = res.data.data.url;
        imageId.value = res.data.data.id;
        resolve(res);
        // message.success(res.data.message);
      })
      .catch((err) => {
        reject(err);
        // message.error('上传失败');
      });
  });
};

const uploadImage = (info: FileInfo, id: number) => {
  if (info.file?.response?.code === 200) {
    // if (id === 1) {
    //   imageUrl.value = info.file?.response?.data.url;
    //   imageId.value = info.file?.response?.data.id;
    //   console.log(imageId.value);
    // }
    if (id === 2) {
      if (consoleStore.robotInfo.lock) {
        message.destroy();
        message.error('当前处于锁定状态，不能操作修改头像！');
      } else {
        consoleStore.robotInfo.avatar_url = info.file?.response?.data.url;
        consoleStore.robotInfo.avatar_id = info.file?.response?.data.id;
        editLockRobotInfo();
      }
    }
    if (id == 3) {
      avatarUrl.value = info.file?.response?.data.url;
      identityAvatarId.value = info.file?.response?.data.id;
    }
  }
  if (info.file.status === 'error') {
    message.error('上传失败');
  }
};
const imageDel = () => {
  imageUrl.value = '';
  imageId.value = '';
  avatarUrl.value = '';
  identityAvatarId.value = '';
  // identityAvatarId.value = '';
};

const packetRef = ref();
const popoverRef = ref();
const robotRef = ref();
const comment = ref(false);
const onClickmsgTool = (e: MouseEvent) => {
  if (showPacket.value && !packetRef.value.contains(e.target) && showPacket.value) {
    showPacket.value = false;
  }
  if (!robotRef.value.contains(e.target) && robotChat.value) {
    robotChat.value = false;
  }
  if (!robotRef.value.contains(e.target) && comment.value) {
    comment.value = false;
  }
};
const onHideList = () => {
  robotChat.value = false;
};
const closeComment = () => {
  comment.value = false;
};
const clickUseR = (type: number) => {
  switch (type) {
    case 1:
      robotChat.value = !robotChat.value;
      comment.value = false;
      break;
    case 2:
      comment.value = !comment.value;
      robotChat.value = false;
      break;
  }
};
onMounted(() => {
  document.addEventListener('click', onClickmsgTool);
});
onUnmounted(() => {
  document.removeEventListener('click', onClickmsgTool);
});
// 表情
const AppendMessageText = (formData: RootEmoji) => {
  const selection = document.getSelection();
  let range: any = selection?.getRangeAt(0);
  range?.deleteContents();
  let el = document.createElement('div');
  el.innerHTML = formData.content;
  let frag = document.createDocumentFragment(),
    node,
    lastNode;
  while ((node = el.firstChild)) {
    lastNode = frag.appendChild(node);
  }
  range?.insertNode(frag);
  if (lastNode) {
    range = range?.cloneRange();
    range.setStartAfter(lastNode);
    range.collapse(true);
    selection?.removeAllRanges();
    selection?.addRange(range);
  }
};
const closeEmoji = (show: any) => {
  showEmoj.value = show;
};
//  关闭投票
const closeVote = (show: boolean) => {
  voteVisible.value = show;
};
// 管理员
const administrator = ref();
// 机器人锁事件
const sculpture = ref();
const robotLock = () => {
  consoleStore.robotInfo.lock = consoleStore.robotInfo.lock ? 0 : 1;
  editLockRobotInfo();
  // robotName.value = false
};
const avatarVisible = ref(false);
const hideModal = () => {
  avatarVisible.value = false;
};
const showAvatar = () => {
  avatarVisible.value = true;
  identityConfiguration();
};
// 获取锁定机器人信息
const lockRobotInfo = () => {
  http.liveChat
    .getLockRobotInfo({ params: { studio_id: route.params.studioId } })
    .then((res: any) => {
      const locks = res.data.data;
      locks.random_area = locks.random_area ? true : false;
      locks.INT_random_area = locks.INT_random_area ? true : false;
      consoleStore.robotInfo = {
        ...locks,
      };
    })
    .catch((res: any) => {
      message.destroy();
      message.error(res.data.error);
    });
};
// 修改锁定机器人信息
const editLockRobotInfo = () => {
  http.liveChat
    .getEditLockRobotInfo({
      studio_id: route.params.studioId,
      avatar_id: consoleStore.robotInfo.avatar_id,
      avatar_url: consoleStore.robotInfo.avatar_url,
      lock: consoleStore.robotInfo.lock,
      name: consoleStore.robotInfo.name,
      robot_id: consoleStore.robotInfo.id,
    })
    .then((res) => {
      if (res.data.code == 200) {
        message.destroy();
        message.success(res.data.message);
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};
//  获取随机机器人信息
const randomRobotInfo = () => {
  http.liveChat
    .getRandomRobotInfo()
    .then((res) => {
      const randomBot = res.data.data;
      consoleStore.robotInfo = randomBot;
    })
    .catch((res: any) => {
      message.destroy();
      message.error(res.data.error);
    });
};
//  机器人刷新
const robotRefresh = () => {
  if (!consoleStore.robotInfo.lock) {
    randomRobotInfo();
  } else {
    message.destroy();
    message.error('当前处于锁定状态，不能操作刷新！');
  }
};
// 获取官方身份配置信息
const avatarUrl = ref('');
const identityAvatarId = ref('');
const nickName = ref(' ');
const identityConfiguration = () => {
  let identity = {
    studio_id: route.params.studioId,
  };
  http.liveChat
    .getIdentityConfiguration({ params: identity })
    .then((res) => {
      const info = res.data.data;
      avatarUrl.value = info.avatar_url;
      identityAvatarId.value = info.avatar_id;
      nickName.value = info.nike_name;
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};
// / 添加or修改官方身份信息
// const loading = ref<boolean>(false);
const keep = () => {
  let changeIdentity = {
    studio_id: route.params.studioId,
    nike_name: nickName.value,
    avatar_id: identityAvatarId.value,
  };
  http.liveChat
    .getChangeIdentityConfiguration(changeIdentity)
    .then((res) => {
      if (res.data.code == 200) {
        message.destroy();
        message.success(res.data.message);
        avatarVisible.value = false;
        consoleStore.authority.avatar_url = avatarUrl.value;
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
  // loading.value = true;
  // setTimeout(() => {
  //   loading.value = false;
  //
  // }, 1000);
};
const cancel = () => {
  avatarVisible.value = false;
};

const selectValue = ref<number>();
const lable = [
  '北京市',
  '天津市',
  '河北省',
  '山西省',
  '内蒙古自治区',
  '辽宁省',
  '吉林省',
  '黑龙江省',
  '上海市',
  '江苏省',
  '浙江省',
  '安徽省',
  '福建省',
  '江西省',
  '山东省',
  '台湾省',
  '河南省',
  '湖北省',
  '湖南省',
  '广东省',
  '广西壮族自治区',
  '海南省',
  '香港',
  '澳门',
  '重庆市',
  '四川省',
  '贵州省',
  '云南省',
  '西藏自治区',
  '陕西省',
  '甘肃省',
  '青海省',
  '宁夏回族自治区',
  '新疆维吾尔自治区',
  '美国',
  '俄罗斯',
  '英国',
  '法国',
  '日本',
  '韩国',
  '德国',
  '印度',
  '西班牙',
  '巴西',
  '意大利',
];
const value = reactive<number[]>([]);
for (let i = 0; i < lable.length; i++) {
  value.push(i);
}
const options = value.map((value, index) => ({ value, label: lable[index] }));
const changeRobotAdree = () => {
  http.liveChat
    .setRobotAdree({
      studio_id: route.params.studioId,
      random_area: consoleStore.robotInfo.random_area ? 1 : 0,
      INT_random_area: consoleStore.robotInfo.INT_random_area ? 1 : 0,
    })
    .then((res) => {
      message.success(res.data.message);
    })
    .catch((err) => message.error(err.data.error));
};
const robotAdress = ref('');
const handleChangeAdress = (value: number) => {
  robotAdress.value = options[value].label;
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_input = _resolveComponent("a-input")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(aSwitch), {
          checked: _unref(consoleStore).consoleInfo.chatVisible,
          size: "small",
          class: "chat_watch_witch",
          onChange: onChangeChatShow
        }, null, 8, ["checked"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          ref_key: "chatSetBtnRef",
          ref: chatSetBtnRef,
          class: "chat_operate_btn_wrap"
        }, [
          _createVNode(_unref(aButton), {
            type: "link",
            class: "chat_operate_btn",
            onClick: openOperaVisible
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_icon, { "icon-class": "chat_set" }),
              _createTextVNode(" 设置")
            ]),
            _: 1
          }),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(aCheckbox), {
              checked: _unref(consoleStore).consoleInfo.groupStatus,
              "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_unref(consoleStore).consoleInfo.groupStatus) = $event)),
              class: "operate_item",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (onChangeSet(0)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("允许观众聊天")
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_unref(aCheckbox), {
              checked: _unref(consoleStore).consoleInfo.anonymousStatus,
              "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_unref(consoleStore).consoleInfo.anonymousStatus) = $event)),
              class: "operate_item",
              onChange: _cache[3] || (_cache[3] = ($event: any) => (onChangeSet(1)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("允许观众匿名聊天")
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_unref(aCheckbox), {
              checked: _unref(consoleStore).consoleInfo.privateStatus,
              "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_unref(consoleStore).consoleInfo.privateStatus) = $event)),
              class: "operate_item",
              onChange: _cache[5] || (_cache[5] = ($event: any) => (onChangeSet(2)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("允许观众私聊")
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_unref(aCheckbox), {
              checked: _unref(consoleStore).consoleInfo.barrageVisible,
              "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_unref(consoleStore).consoleInfo.barrageVisible) = $event)),
              class: "operate_item",
              onChange: _cache[7] || (_cache[7] = ($event: any) => (onChangeSet(3)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("显示弹幕")
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_unref(aCheckbox), {
              checked: _unref(consoleStore).consoleInfo.barrageReview,
              "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((_unref(consoleStore).consoleInfo.barrageReview) = $event)),
              class: "operate_item",
              onChange: _cache[9] || (_cache[9] = ($event: any) => (onChangeSet(4)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("弹幕需要审核")
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_unref(aCheckbox), {
              checked: _unref(consoleStore).consoleInfo.reviewStatus,
              "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((_unref(consoleStore).consoleInfo.reviewStatus) = $event)),
              class: "operate_item",
              onChange: _cache[11] || (_cache[11] = ($event: any) => (onChangeSet(5)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("发送内容需要审核")
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_unref(aCheckbox), {
              checked: _unref(consoleStore).consoleInfo.commentNumVisible,
              "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((_unref(consoleStore).consoleInfo.commentNumVisible) = $event)),
              class: "operate_item",
              onChange: _cache[13] || (_cache[13] = ($event: any) => (onChangeSet(6)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("显示评论数")
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_unref(aCheckbox), {
              checked: _unref(consoleStore).consoleInfo.notityStatus,
              "onUpdate:checked": _cache[14] || (_cache[14] = ($event: any) => ((_unref(consoleStore).consoleInfo.notityStatus) = $event)),
              class: "operate_item",
              onChange: _cache[15] || (_cache[15] = ($event: any) => (onChangeSet(7)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("观众进入直播间提示")
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_unref(aCheckbox), {
              checked: _unref(consoleStore).consoleInfo.picStatus,
              "onUpdate:checked": _cache[16] || (_cache[16] = ($event: any) => ((_unref(consoleStore).consoleInfo.picStatus) = $event)),
              class: "operate_item",
              onChange: _cache[17] || (_cache[17] = ($event: any) => (onChangeSet(8)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("允许发送图片")
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_unref(aCheckbox), {
              checked: _unref(consoleStore).consoleInfo.addressStatus,
              "onUpdate:checked": _cache[18] || (_cache[18] = ($event: any) => ((_unref(consoleStore).consoleInfo.addressStatus) = $event)),
              class: "operate_item",
              onChange: _cache[19] || (_cache[19] = ($event: any) => (onChangeSet(9)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("观众IP属地")
              ]),
              _: 1
            }, 8, ["checked"])
          ], 512), [
            [_vShow, operaVisible.value]
          ])
        ], 512),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(aButton), {
            type: "link",
            class: "chat_operate_btn",
            onClick: onClearMsg
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_icon, { "icon-class": "chat_empty" }),
              _createTextVNode(" 清空")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          ref_key: "exportRef",
          ref: exportRef,
          class: "chat_operate_btn_wrap"
        }, [
          _createVNode(_unref(aButton), {
            type: "link",
            class: "chat_operate_btn"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_icon, { "icon-class": "chat_export_set" }),
              _createTextVNode(" 导出")
            ]),
            _: 1
          }),
          _withDirectives(_createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createTextVNode(" 聊天类型： "),
              _createVNode(_unref(aRadioGroup), {
                value: exportForm.chatType,
                "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((exportForm.chatType) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(aRadio), { value: 8 }, {
                    default: _withCtx(() => [
                      _createTextVNode("群聊")
                    ]),
                    _: 1
                  }),
                  (_unref(consoleStore).consoleInfo.chatType === 2)
                    ? (_openBlock(), _createBlock(_unref(aRadio), {
                        key: 0,
                        value: 9
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("私聊")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createTextVNode(" 内容选择： "),
              _createVNode(_unref(aRadioGroup), {
                value: exportForm.contentType,
                "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((exportForm.contentType) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(aRadio), { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("全部内容")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aRadio), { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("审核过的")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(aButton), {
                type: "primary",
                onClick: _unref(onExportChat)
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ], 512), [
            [_vShow, exportForm.visible]
          ])
        ], 512)
      ])
    ]),
    (_unref(consoleStore).groupListScrollStatus && _unref(consoleStore).groupProvisionalList.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "chat_bubble",
          onClick: onScrollTop
        }, [
          _createVNode(_unref(DoubleRightOutlined), { class: "chat_bubble_icon" }),
          _createTextVNode(" " + _toDisplayString(_unref(consoleStore).groupProvisionalList.length > 99 ? '99' : _unref(consoleStore).groupProvisionalList.length) + " 条新消息 ", 1)
        ]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      ref_key: "msgRef",
      ref: msgRef,
      "infinite-scroll-delay": 500,
      "infinite-scroll-distance": 300,
      "infinite-scroll-immediate": false,
      class: "chat_content_wrap"
    }, [
      (_unref(consoleStore).consoleInfo.chatType === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_unref(LightGroupMessage))
          ]))
        : (checkedTab(0))
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(consoleStore).currentDialog.list, (item) => {
                return (_openBlock(), _createBlock(ChatMessage, {
                  key: item.msg_id,
                  "source-data": item,
                  self: item.uid === _unref(consoleStore).authority.uid
                }, null, 8, ["source-data", "self"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_unref(GroupMessage))
            ]))
    ])), [
      [_directive_infinite_scroll, updateList]
    ]),
    (_unref(consoleStore).consoleInfo.chatType === 2)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          ref_key: "chatlistRef",
          ref: chatlistRef,
          class: "chat_switch_wrap",
          onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: _normalizeClass([{ checked: checkedTab(0) }, "chat_switch_tabpane"]),
              onClick: _cache[22] || (_cache[22] = ($event: any) => (onChangeChatType(0)))
            }, [
              _createVNode(_unref(aBadge), {
                class: "chat_switch_tabpane_badge",
                count: _unref(consoleStore).privateMsg.newMsgCount
              }, null, 8, ["count"]),
              _createTextVNode("私聊列表 ")
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass([{ checked: checkedTab(1) }, "chat_switch_tabpane"]),
              onClick: _cache[23] || (_cache[23] = ($event: any) => (onChangeChatType(1)))
            }, "公共列表", 2)
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_Transition, { name: "private_list" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(consoleStore).privateMsg.list, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: _normalizeClass(["chat_switch_item", { actived: item.id === _unref(consoleStore).currentDialog.pmsgItem.id }]),
                      onClick: ($event: any) => (onSwitchInfo(item))
                    }, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("img", {
                          src: item.to_avatar_url,
                          alt: ""
                        }, null, 8, _hoisted_20)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(item.to_nickname), 1),
                        _createElementVNode("div", {
                          innerHTML: item.new_record,
                          class: "csic_message mod_ellip"
                        }, null, 8, _hoisted_23),
                        _createVNode(_unref(aBadge), {
                          class: "csic_badge",
                          dot: true,
                          count: item.news
                        }, null, 8, ["count"])
                      ])
                    ], 10, _hoisted_18))
                  }), 128))
                ], 512), [
                  [_vShow, listVisible.value]
                ])
              ]),
              _: 1
            })
          ])), [
            [_directive_infinite_scroll, _unref(updatePrivateList)]
          ])
        ], 512))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", {
          ref_key: "popoverRef",
          ref: popoverRef,
          class: "chat_select"
        }, [
          _createVNode(_unref(aPopover), {
            visible: showEmoj.value,
            "onUpdate:visible": _cache[27] || (_cache[27] = ($event: any) => ((showEmoj).value = $event)),
            trigger: "click"
          }, {
            content: _withCtx(() => [
              _createVNode(_unref(EmojiDrawer), {
                onMousedown: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["prevent"])),
                onAppendInputValue: AppendMessageText,
                onViewStatus: closeEmoji
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_unref(aTooltip), { placement: "bottom" }, {
                  title: _withCtx(() => [
                    _hoisted_27
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(aButton), {
                      type: "link",
                      class: "nav_img",
                      onMousedown: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["prevent"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_svg_icon, { "icon-class": "control_emoji" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["visible"]),
          (_unref(consoleStore).chatType === 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_unref(aTooltip), { placement: "bottom" }, {
                    title: _withCtx(() => [
                      _hoisted_29
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(aUpload), {
                        "file-list": fileList.value,
                        showUploadList: false,
                        remove: handleRemove,
                        accept: ".jpg,.jpeg,.png,.gif",
                        "before-upload": beforeUpload,
                        class: "upload_img"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(aButton), {
                            type: "link",
                            class: "nav_img",
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (showSend(2)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_icon, { "icon-class": "control_upload" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["file-list"])
                    ]),
                    _: 1
                  })
                ]),
                (_unref(isParentStudio))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createVNode(_unref(aTooltip), { placement: "bottom" }, {
                        title: _withCtx(() => [
                          _hoisted_31
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(aButton), {
                            type: "link",
                            class: _normalizeClass(["nav_img", _unref(consoleStore).robotVisible ? 'cutIsactive' : 'cutUnactive']),
                            onClick: _cache[29] || (_cache[29] = ($event: any) => (showSend(6)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_svg_icon, { "icon-class": "control_robot" })
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_unref(aTooltip), { placement: "bottom" }, {
                          title: _withCtx(() => [
                            _hoisted_33
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(aButton), {
                              type: "link",
                              class: "nav_img",
                              onClick: _cache[30] || (_cache[30] = ($event: any) => (showSend(3)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_svg_icon, { "icon-class": "control_vote" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_unref(aTooltip), { placement: "bottom" }, {
                          title: _withCtx(() => [
                            _hoisted_35
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(aButton), {
                              type: "link",
                              class: "nav_img",
                              onClick: _cache[31] || (_cache[31] = ($event: any) => (showSend(4)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_svg_icon, { "icon-class": "control_clock" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_unref(aTooltip), { placement: "bottom" }, {
                          title: _withCtx(() => [
                            _hoisted_37
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(aButton), {
                              type: "link",
                              class: "nav_img",
                              onClick: _cache[32] || (_cache[32] = ($event: any) => (showSend(5)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_svg_icon, { "icon-class": "control_people" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_unref(aTooltip), { placement: "bottom" }, {
                          title: _withCtx(() => [
                            _hoisted_39
                          ]),
                          default: _withCtx(() => [
                            (_unref(discussRole))
                              ? (_openBlock(), _createBlock(_unref(aButton), {
                                  key: 0,
                                  type: "link",
                                  class: _normalizeClass(["nav_img", _unref(consoleStore).robotVisible ? 'cutIsactive' : 'cutUnactive']),
                                  onClick: _cache[33] || (_cache[33] = ($event: any) => (showSend(6)))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_icon, { "icon-class": "control_robot" })
                                  ]),
                                  _: 1
                                }, 8, ["class"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_unref(aTooltip), { placement: "bottom" }, {
                          title: _withCtx(() => [
                            _hoisted_41
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(aButton), {
                              type: "link",
                              class: "nav_img",
                              onClick: _cache[34] || (_cache[34] = ($event: any) => (showSend(7)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_svg_icon, { "icon-class": "control_popup" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      (_unref(aiSubitilesRole))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createVNode(_unref(aTooltip), { placement: "bottom" }, {
                              title: _withCtx(() => [
                                _hoisted_43
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_unref(aButton), {
                                  type: "link",
                                  class: "nav_img",
                                  onClick: _cache[35] || (_cache[35] = ($event: any) => (showSend(10)))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_icon, { "icon-class": "control_aisubtitles" })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(RedEnvelope))
                        ? (_openBlock(), _createBlock(_unref(aPopover), {
                            key: 1,
                            "get-popup-container": () => popoverRef.value,
                            visible: packetVisible.value,
                            "onUpdate:visible": _cache[40] || (_cache[40] = ($event: any) => ((packetVisible).value = $event)),
                            trigger: "click"
                          }, {
                            content: _withCtx(() => [
                              (_unref(homeStore).funcData.competitive_red_envelope)
                                ? (_openBlock(), _createBlock(_unref(aButton), {
                                    key: 0,
                                    type: "link",
                                    class: "lottery_but",
                                    onClick: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (packetView(1)), ["stop"]))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("竞答红包")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_unref(homeStore).funcData.PasswordRedEnvelope)
                                ? (_openBlock(), _createBlock(_unref(aButton), {
                                    key: 1,
                                    type: "link",
                                    class: "lottery_but",
                                    onClick: _cache[37] || (_cache[37] = _withModifiers(($event: any) => (packetView(2)), ["stop"]))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("口令红包")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_unref(homeStore).funcData.QuotaRedEnvelope)
                                ? (_openBlock(), _createBlock(_unref(aButton), {
                                    key: 2,
                                    type: "link",
                                    class: "lottery_but",
                                    onClick: _cache[38] || (_cache[38] = _withModifiers(($event: any) => (packetView(3)), ["stop"]))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("定额红包")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_unref(homeStore).funcData.MatchLuckyRedEnvelope)
                                ? (_openBlock(), _createBlock(_unref(aButton), {
                                    key: 3,
                                    type: "link",
                                    class: "lottery_but",
                                    onClick: _cache[39] || (_cache[39] = _withModifiers(($event: any) => (packetView(4)), ["stop"]))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("拼手气红包")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_44, [
                                _createVNode(_unref(aTooltip), { placement: "bottom" }, {
                                  title: _withCtx(() => [
                                    _hoisted_45
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_unref(aButton), {
                                      type: "link",
                                      class: "nav_img"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_svg_icon, { "icon-class": "control_red_packet" })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["get-popup-container", "visible"]))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(aPopover), {
                        visible: lotteryDrawer.btnVisible,
                        "onUpdate:visible": _cache[43] || (_cache[43] = ($event: any) => ((lotteryDrawer.btnVisible) = $event)),
                        trigger: "click"
                      }, {
                        content: _withCtx(() => [
                          _createVNode(_unref(aButton), {
                            type: "link",
                            class: "lottery_select",
                            onClick: _cache[41] || (_cache[41] = ($event: any) => (showSend(9, 1)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("普通抽奖")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(aButton), {
                            type: "link",
                            class: "lottery_select",
                            onClick: _cache[42] || (_cache[42] = ($event: any) => (showSend(9, 2)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("活动抽奖")
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_unref(aTooltip), { placement: "bottom" }, {
                              title: _withCtx(() => [
                                _hoisted_47
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_unref(aButton), {
                                  type: "link",
                                  class: "nav_img"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_icon, { "icon-class": "control_luck_draw" })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["visible"])
                    ], 64))
              ], 64))
            : _createCommentVNode("", true)
        ], 512),
        _createVNode(_unref(aTooltip), { placement: "bottom" }, {
          title: _withCtx(() => [
            _hoisted_48
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "chat_avatar",
              onClick: showAvatar
            }, [
              _withDirectives(_createElementVNode("img", {
                src: _unref(consoleStore).authority.avatar_url,
                alt: ""
              }, null, 8, _hoisted_49), [
                [_vShow, _unref(consoleStore).authority.avatar_url]
              ])
            ])
          ]),
          _: 1
        }),
        (_unref(isParentStudio))
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, "部分功能请前往对应直播间操作"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_51, [
        (imageUrl.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
              (imgLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createVNode(_unref(LoadingOutlined))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_unref(ZoomInOutlined), { class: "look" }),
                      _createVNode(_unref(aImage), {
                        width: 18,
                        src: imageUrl.value
                      }, null, 8, ["src"]),
                      _createVNode(_unref(DeleteOutlined), { onClick: imageDel })
                    ])
                  ])),
              _createElementVNode("img", { src: imageUrl.value }, null, 8, _hoisted_56)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_unref(aModal), {
        visible: avatarVisible.value,
        "onUpdate:visible": _cache[45] || (_cache[45] = ($event: any) => ((avatarVisible).value = $event)),
        title: "官方配置",
        onOk: hideModal,
        centered: "",
        closable: false,
        class: "official_config",
        footer: null
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _createElementVNode("div", _hoisted_60, [
                _createVNode(_component_a_input, {
                  value: nickName.value,
                  "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((nickName).value = $event)),
                  class: "area_tex",
                  "show-count": "",
                  maxlength: 20,
                  placeholder: "请输入昵称"
                }, {
                  suffix: _withCtx(() => [
                    _createElementVNode("div", _hoisted_61, _toDisplayString(nickName.value.length) + "/20", 1)
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _hoisted_63,
              _createVNode(CUpload, {
                "file-list": administrator.value,
                "handle-change": (info) => uploadImage(info, 3),
                "image-name": avatarUrl.value,
                "click-stop": imageDel,
                class: "avatar_imges"
              }, null, 8, ["file-list", "handle-change", "image-name"]),
              _createVNode(_unref(aPopover), { placement: "rightTop" }, {
                content: _withCtx(() => [
                  _hoisted_64
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_65, [
              _createVNode(_unref(aButton), {
                class: "mod_modal_btn",
                onClick: cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              }),
              _createVNode(_unref(aButton), {
                class: "mod_modal_btn mod_type_primary",
                onClick: keep
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createElementVNode("div", {
        ref_key: "chatInputRef",
        ref: chatInputRef,
        class: "chat_send_content",
        contenteditable: "true",
        style: _normalizeStyle([{"-webkit-user-select":"auto"}, { height: _unref(consoleStore).robotVisible ? '58px' : '105px' }]),
        onKeydown: _withKeys(replaceEnter, ["enter"]),
        onPaste: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_unref(onPaste) && _unref(onPaste)(...args))),
        onMousedown: _cache[47] || (_cache[47] = _withModifiers(() => {}, ["stop"]))
      }, null, 44, _hoisted_66)
    ]),
    _withDirectives(_createElementVNode("div", {
      ref_key: "robotRef",
      ref: robotRef,
      class: "chat_robot"
    }, [
      _createVNode(CUpload, {
        "file-list": sculpture.value,
        "handle-change": (info) => uploadImage(info, 2),
        plus: false,
        mask: false,
        "image-name": _unref(consoleStore).robotInfo.avatar_url,
        class: "robot_sculp",
        disabled: _unref(consoleStore).robotInfo.lock
      }, {
        uploadImg: _withCtx(() => [
          _createElementVNode("div", _hoisted_67, [
            _withDirectives(_createElementVNode("img", {
              src: _unref(consoleStore).robotInfo.avatar_url,
              alt: "",
              class: "avatar_img"
            }, null, 8, _hoisted_68), [
              [_vShow, _unref(consoleStore).robotInfo.avatar_url]
            ])
          ])
        ]),
        _: 1
      }, 8, ["file-list", "handle-change", "image-name", "disabled"]),
      _createElementVNode("div", _hoisted_69, [
        _createVNode(_component_a_input, {
          value: _unref(consoleStore).robotInfo.name,
          "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((_unref(consoleStore).robotInfo.name) = $event)),
          class: "robot_input",
          disabled: _unref(consoleStore).robotInfo.lock === 1,
          onBlur: editLockRobotInfo
        }, null, 8, ["value", "disabled"]),
        _createElementVNode("div", _hoisted_70, [
          _createVNode(_unref(aPopover), { placement: "bottom" }, {
            content: _withCtx(() => [
              _createTextVNode(" 使用记录 ")
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(aButton), {
                type: "link",
                class: "robot_button"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    "icon-class": "control_more",
                    class: "robot_icon",
                    onClick: _cache[49] || (_cache[49] = ($event: any) => (clickUseR(1)))
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(aPopover), { placement: "bottom" }, {
            content: _withCtx(() => [
              _createTextVNode(" 评论库 ")
            ]),
            default: _withCtx(() => [
              _withDirectives(_createVNode(_unref(aButton), {
                type: "link",
                class: "robot_button"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    "icon-class": "comments_actived",
                    class: "robot_icon",
                    onClick: _cache[50] || (_cache[50] = ($event: any) => (clickUseR(2)))
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, _unref(consoleStore).consoleInfo.chatType !== 2 && comment.value]
              ]),
              _withDirectives(_createVNode(_unref(aButton), {
                type: "link",
                class: "robot_button"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    "icon-class": "comments_icon",
                    class: "robot_icon",
                    onClick: _cache[51] || (_cache[51] = ($event: any) => (clickUseR(2)))
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, _unref(consoleStore).consoleInfo.chatType !== 2 && !comment.value]
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(aPopover), { placement: "bottom" }, {
            content: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(consoleStore).robotInfo.lock ? '解锁' : '锁定'), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(aButton), {
                type: "link",
                class: "robot_button"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    value: _unref(consoleStore).robotInfo.lock,
                    "onUpdate:value": _cache[52] || (_cache[52] = ($event: any) => ((_unref(consoleStore).robotInfo.lock) = $event)),
                    "icon-class": _unref(consoleStore).robotInfo.lock ? 'control_locks' : 'control_lock',
                    class: "robot_icon",
                    onClick: robotLock
                  }, null, 8, ["value", "icon-class"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(aPopover), { placement: "bottom" }, {
            content: _withCtx(() => [
              _createTextVNode(" 刷新 ")
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(aButton), {
                type: "link",
                class: "robot_button"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    "icon-class": "control_refresh",
                    class: "robot_icon",
                    onClick: robotRefresh
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(aPopover), {
            placement: "top",
            trigger: "click",
            "get-popup-container": () => robotRef.value
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _hoisted_73,
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_74, [
                      _createTextVNode(" 中国大陆  "),
                      _createVNode(_unref(aSwitch), {
                        checked: _unref(consoleStore).robotInfo.random_area,
                        "onUpdate:checked": _cache[53] || (_cache[53] = ($event: any) => ((_unref(consoleStore).robotInfo.random_area) = $event)),
                        onChange: changeRobotAdree
                      }, null, 8, ["checked"])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createTextVNode(" 国际/港澳台  "),
                      _createVNode(_unref(aSwitch), {
                        checked: _unref(consoleStore).robotInfo.INT_random_area,
                        "onUpdate:checked": _cache[54] || (_cache[54] = ($event: any) => ((_unref(consoleStore).robotInfo.INT_random_area) = $event)),
                        onChange: changeRobotAdree
                      }, null, 8, ["checked"])
                    ])
                  ])
                ]),
                (!_unref(consoleStore).robotInfo.random_area && !_unref(consoleStore).robotInfo.INT_random_area)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      _hoisted_77,
                      _createVNode(_unref(aSelect), {
                        value: selectValue.value,
                        "onUpdate:value": _cache[55] || (_cache[55] = ($event: any) => ((selectValue).value = $event)),
                        "get-popup-container": () => robotRef.value,
                        options: _unref(options),
                        style: {"width":"100px"},
                        onChange: handleChangeAdress
                      }, null, 8, ["value", "get-popup-container", "options"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(aPopover), { placement: "bottom" }, {
                content: _withCtx(() => [
                  _createTextVNode(" 随机地区 ")
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(aButton), {
                    type: "link",
                    class: "robot_button"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_icon, {
                        "icon-class": "control_location",
                        class: "robot_icon"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["get-popup-container"])
        ])
      ]),
      _createElementVNode("div", _hoisted_78, [
        (robotChat.value)
          ? (_openBlock(), _createBlock(_unref(RobotRecord), {
              key: 0,
              "onUpdate:onHideList": onHideList
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_79, [
        (comment.value)
          ? (_openBlock(), _createBlock(_unref(Comment), {
              key: 0,
              "onClick:close": closeComment
            }))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, _unref(consoleStore).robotVisible]
    ]),
    _createVNode(_unref(aButton), {
      class: "chat_btn",
      onClick: sendMsg
    }, {
      default: _withCtx(() => [
        _createTextVNode("发送")
      ]),
      _: 1
    }),
    (activedKey.value == 5)
      ? (_openBlock(), _createBlock(_unref(aDrawer), {
          key: 2,
          placement: "right",
          width: "613",
          closable: false,
          visible: lotteryDrawer.numberPeople,
          "onUpdate:visible": _cache[56] || (_cache[56] = ($event: any) => ((lotteryDrawer.numberPeople) = $event)),
          "wrap-class-name": "peopleControl",
          class: "people_draw",
          onClose: onCloseLotter
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NumberSetting), { "onClick:onCloseLotter": onCloseLotter })
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true),
    (activedKey.value == 4)
      ? (_openBlock(), _createBlock(_unref(aDrawer), {
          key: 3,
          placement: "right",
          width: "613",
          visible: lotteryDrawer.punch,
          closable: false,
          "wrap-class-name": "punchControl",
          onClose: onCloseLotter,
          destroyOnClose: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(PunchClock), { "onClick:onCloseLotter": onCloseLotter })
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(aDrawer), {
      visible: voteVisible.value,
      "onUpdate:visible": _cache[57] || (_cache[57] = ($event: any) => ((voteVisible).value = $event)),
      placement: "right",
      width: 613,
      closable: false
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(VoteDrawer)), { onClose: closeVote }, null, 32))
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(aDrawer), {
      placement: "right",
      width: "613",
      visible: lotteryDrawer.popup,
      closable: false,
      "wrap-class-name": "popupControl",
      onClose: onCloseLotter,
      destroyOnClose: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(PopupAdverst), { "onClick:onCloseLotter": onCloseLotter })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(aDrawer), {
      placement: "right",
      width: "613",
      visible: lotteryDrawer.aistr,
      closable: false,
      "wrap-class-name": "popupControl",
      onClose: onCloseLotter,
      destroyOnClose: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(AiSubtitles), { "onClick:onCloseLotter": onCloseLotter })
      ]),
      _: 1
    }, 8, ["visible"]),
    (showPacket.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          ref_key: "packetRef",
          ref: packetRef,
          class: "mode_packet"
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(RedPacket)), {
            data: { packType: packType.value, showPacket: showPacket.value },
            "onClick:close": closeThis,
            class: "mode_packet_size"
          }, null, 40, ["data"]))
        ], 512))
      : _createCommentVNode("", true),
    _createVNode(_unref(aDrawer), {
      visible: lotteryDrawer.LayoutVisible,
      "onUpdate:visible": _cache[58] || (_cache[58] = ($event: any) => ((lotteryDrawer.LayoutVisible) = $event)),
      closable: false,
      placement: "right",
      width: "613",
      onClose: onCloseLotter
    }, {
      default: _withCtx(() => [
        (lotteryDrawer.LayoutVisible && lotteryDrawer.type === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
              _createVNode(_unref(StandLogttery), { "onClick:onCloseLotter": onCloseLotter })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_81, [
              _createVNode(_unref(ActivityLogttery), { "onClick:onCloseLotter": onCloseLotter })
            ]))
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})